import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import activityTrackingService from '../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../constants'
import { propertyActions } from '../../../../redux/actions/property'

// single source of truth for whether a property publish may be dispatched.
// shared by PublishAllButton and the notification center so neither can bypass
// the guards (unsaved changes, unconfirmed/no property images).
const usePublishGuard = ({ giataId, publishAllowed = true }) => {
  const dispatch = useDispatch()
  const hasUnpublishedChanges = useSelector(state => state.property.hasUnpublishedChanges)
  const publishInProgress = useSelector(state => state.property.publishInProgress)
  const isBlockedUnconfirmedImages = useSelector(state => state.property.isPublishBlockedDueToUnconfirmedImages)
  const isBlockedNoPropertyImages = useSelector(state => state.property.isPublishBlockedDueToNoPropertyImages)
  const isBlockedByImages = isBlockedUnconfirmedImages || isBlockedNoPropertyImages

  const canPublish = !!giataId
    && publishAllowed
    && hasUnpublishedChanges
    && !publishInProgress
    && !isBlockedByImages

  // returns whether the publish was dispatched. eventProperties are added to
  // the tracked publish event (e.g. where it was triggered from).
  const publish = useCallback((eventProperties) => {
    if (!canPublish) {
      return false
    }
    activityTrackingService.trackEvent(trackingEvent.publishProperty, eventProperties)
    dispatch(propertyActions.publish(giataId))
    return true
  }, [canPublish, dispatch, giataId])

  return {
    hasUnpublishedChanges,
    publishInProgress,
    isBlockedUnconfirmedImages,
    isBlockedNoPropertyImages,
    isBlockedByImages,
    canPublish,
    publish,
  }
}

export default usePublishGuard
